import store from '@/store';
import { authGuard } from '@auth0/auth0-vue';
import { auth0 } from '@/utils/auth0';
import { RouteNames } from '@/data/routes';

import OnboardingLayout from '@/pages/onboarding/OnboardingLayout.vue';
import OnboardingProfilePage from '@/pages/onboarding/OnboardingProfilePage.vue';
import OnboardingBusinessPage from '@/pages/onboarding/OnboardingBusinessPage.vue';
import OnboardingBusinessAddressPage from '@/pages/onboarding/OnboardingBusinessAddressPage.vue';
import OnboardingRevenueAccountPage from '@/pages/onboarding/OnboardingRevenueAccountPage.vue';
import OnboardingInvitedUserIdUploadPage from '@/pages/onboarding/OnboardingInvitedUserIdUploadPage.vue';
import OnboardingInvitedUserVerificationPage from '@/pages/onboarding/OnboardingInvitedUserVerificationPage.vue';
import OnboardingInvitedUserDetailsPage from '@/pages/onboarding/OnboardingInvitedUserDetailsPage.vue';
import { RouteLocation, NavigationGuardNext } from 'vue-router';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/onboarding',
  name: RouteNames.ONBOARDING.INDEX,
  component: OnboardingLayout,
  beforeEnter: [
    authGuard,
    (to: RouteLocation, _from: RouteLocation, next: NavigationGuardNext) => {
      // Allow users to navigate directly to revenue-account so OAuth callback can successfully register external accounts
      if (to.name === RouteNames.ONBOARDING.REVENUE_ACCOUNT) {
        return next();
      }

      const incompleteStep = store.getters.firstIncompleteOnboardingStep;
      if (!!auth0.isAuthenticated?.value && incompleteStep?.name !== to.name) {
        return next({
          name: incompleteStep.name,
        });
      }
      return next();
    },
  ],
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '',
      alias: '/payments/onboarding/user-profile',
      name: RouteNames.ONBOARDING.USER,
      component: OnboardingProfilePage,
    },
    {
      path: 'business',
      alias: '/payments/onboarding/business-details',
      name: RouteNames.ONBOARDING.BUSINESS,
      component: OnboardingBusinessPage,
    },
    {
      path: 'address',
      alias: '/payments/onboarding/registered-address',
      name: RouteNames.ONBOARDING.ADDRESS,
      component: OnboardingBusinessAddressPage,
    },
    {
      path: 'revenue-account',
      name: RouteNames.ONBOARDING.REVENUE_ACCOUNT,
      component: OnboardingRevenueAccountPage,
    },
    {
      path: 'invited',
      name: RouteNames.ONBOARDING.INVITED.INDEX,
      children: [
        {
          path: '',
          name: RouteNames.ONBOARDING.INVITED.USER_DETAILS,
          component: OnboardingInvitedUserDetailsPage,
        },
        {
          path: 'verification',
          name: RouteNames.ONBOARDING.INVITED.VERIFICATION,
          component: OnboardingInvitedUserVerificationPage,
        },
        {
          path: 'id-upload',
          name: RouteNames.ONBOARDING.INVITED.ID,
          component: OnboardingInvitedUserIdUploadPage,
        },
        {
          path: 'revenue-account',
          name: RouteNames.ONBOARDING.INVITED.REVENUE_ACCOUNT,
          component: OnboardingRevenueAccountPage,
          props: {
            invitedRoute: true,
          },
        },
      ],
    },
  ],
});
